import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { InputHelperTextComponent } from 'app/shared/components/input-helper-text/input-helper-text.component';
import { HelperService } from 'app/shared/services/helper.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-status-select-field',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    NgSelectModule,
    InputHelperTextComponent
  ],
  templateUrl: './status-select-field.component.html',
  styleUrl: './status-select-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StatusSelectFieldComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => StatusSelectFieldComponent),
      multi: true,
    }
  ],
})
export class StatusSelectFieldComponent implements ControlValueAccessor, OnInit, OnDestroy {
  @Input() label: string = '';
  @Input() type: string = 'text';
  @Input() placeholder: string = 'placeholders.please_select';
  @Input() isRequired: boolean = false;
  @Input() infoText: string = '';
  @Input() clearable: boolean = false;
  @Input() searchable: boolean = false;
  @Input() bindLabel: string = 'name';
  @Input() bindValue: string = 'id';
  @Input() items:any = [];
  @Input() customClass: string = '';
  @Input() optionItem: string = 'name';
  @Input() itemClass = 'no-data';
  @Input() isDisabledField: boolean = false;
  @Input() isLabelTopPosition: boolean = false;
  @Input() helpText!: string;
  @Output() onSelectEvent = new EventEmitter<void>();

  formControl: FormControl = new FormControl<string>('');
  errorText: string = '';

  private unsubscribe$ = new Subject<void>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private helperService: HelperService
  ) {}

  onTouch: () => void = () => {};
  onChange: (value: any) => void = () => {};

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  writeValue(value: string): void {
    this.formControl.setValue(value, { emitEvent: false });

    this.changeDetectorRef.markForCheck();
  }

  ngOnInit(): void {
    this.formControl.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe((value) => {
        this.itemClass = value ? value : 'no-data';
        this.onChange(value);
      });
  }

  change(data: any) {
    this.onSelectEvent.emit(data);
  }

  validate(control: FormControl) {
    setTimeout(() => {
      this.errorText = this.helperService.handleFieldsErrors(control);
      this.changeDetectorRef.markForCheck();
    });
    return null;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
